export async function loadMarketSnapshot() {
    const response = await fetch('/api/market-data', {
        headers: { accept: 'application/json' },
        credentials: 'include'
    });
    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error ?? `Market data request failed with status ${response.status}`);
    }
    return response.json();
}
export function formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    }).format(value);
}
export function formatPercent(value, digits = 1) {
    return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    }).format(value);
}
